export const carData = {
  "JTDKAMFP4N3226551": {
    vin: "JTDKAMFP4N3226551",
    make: "Toyota",
    model: "Prius Prime Limited",
    year: "11 / 2022",
    body_class: "Hatchback",
    engine: "1.8L Hybrid",
    transmission: "CVT",
    drive_type: "FWD",
    fuel_type: "Plug-in Hybrid",
    mileage: "19523",
    accident_history: "Minor accident reported",
    notes: "VIN: JTDKAMFP4N3226551",
    images: [
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-1.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-2.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-3.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-4.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-5.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-6.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-7.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-8.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-9.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-10.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-11.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-12.jpg",
  "/images/prius/toyota-prius-vin-jtdkamfp4n3226551-13.jpg"
]
  }
};